import { useMetricRecordsById } from "@/metrics/registry"

interface MetricBreadcrumbContentProps {
  metricId: string
  isLast: boolean
}

const STATIC_LABELS: Record<string, string> = {
  create: "Create",
  new: "New",
}

export const MetricBreadcrumbContent = ({
  metricId,
  isLast,
}: MetricBreadcrumbContentProps) => {
  const staticLabel = STATIC_LABELS[metricId]
  const { metricRecordsById, isLoading } = useMetricRecordsById()
  const metric = staticLabel ? undefined : metricRecordsById[metricId]

  const displayName =
    staticLabel ||
    metric?.metric_display_name ||
    metric?.metric_name ||
    metricId

  return (
    <span className={isLast ? "font-semibold" : ""}>
      {!staticLabel && isLoading ? "Loading..." : displayName}
    </span>
  )
}
